const comments = [
  {
    name: '影迷小李',
    text: '萝卜影视的片库真的太全了！找了好久的一部老电影居然在这里找到了高清版，画质超出预期，而且完全免费不用注册，简直是影迷福音。',
    movie: '在看《暗夜追踪者》',
  },
  {
    name: '周末观影人',
    text: '每天都会来看看热门电影排行榜，更新速度很快。最近迷上了国产科幻专题，推荐了好几部之前没关注过的佳作，打开了新世界。',
    movie: '在看《星河纪元：重启》',
  },
  {
    name: '电影发烧友',
    text: '作为资深影迷，萝卜影视的专题策划很有深度。经典修复单元让我重新感受了胶片时代的魅力，4K画质下的老电影焕发新生。',
    movie: '在看经典修复系列',
  },
  {
    name: '追片小能手',
    text: '手机上看也很流畅，通勤路上就能看一部电影。最近悬疑片推荐很准，每部都让人欲罢不能，已经安利给身边所有朋友了。',
    movie: '在看《她的名字》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">观众热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          听听影迷们怎么说，真实用户的观影感受
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-400">{item.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-200">{item.name}</div>
                  <div className="text-xs text-foreground-600">{item.movie}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}